<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="flexs mb20">
        <el-image style="width: 50px; height: 50px;border-radius: 50%;" :src="info.userHeadImg" v-if="info.userHeadImg" :preview-src-list="[info.userHeadImg]"></el-image>
        <img style="width: 50px; height: 50px;" src="@/assets/du_logo.png" v-else />
        <span class="ml10 font16">{{info.realName || ''}}</span>
        <!-- <div class="sex-box flexs"> -->
        <i style="font-size: 13px;" :class="info.sex==1?'el-icon-male':'el-icon-female'" :style="{'color':info.sex==1?'#60B7DC':'#F59494'}"></i>
        <!-- </div> -->
        <div class="font12 label-box">{{info.levelName}}</div>
      </div>
      <el-descriptions class="margin-top" title="" :column="10" direction="vertical" :colon="false" :labelStyle="{'color':'#8F8E8E','paddingBottom':'0px'}">
        <el-descriptions-item label="技术ID">{{info.id}}</el-descriptions-item>
        <el-descriptions-item label="用友编码">{{info.yonYouCode}}</el-descriptions-item>
        <el-descriptions-item label="电话">{{info.mobile}}</el-descriptions-item>
        <el-descriptions-item label="上级" :span="2"><span class="" v-if="info.levelId!=1">{{info.parentRealName}}【{{info.parentLevelName}}】{{info.parentMobile}}</span></el-descriptions-item>
        <el-descriptions-item label="下级团队人数">{{info.childCount || 0}}</el-descriptions-item>
        <el-descriptions-item label="客户人数">{{info.customerCount ||0}}</el-descriptions-item>
        <el-descriptions-item label="所在区域">{{info.provinceName}}{{info.cityName}}{{info.districtName}}</el-descriptions-item>
        <!-- <el-descriptions-item label="注册app时间">{{info.firstLoginAppTime}}</el-descriptions-item> -->
        <el-descriptions-item label="注册时身份">{{info.levelName}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{info.status==10?'在职':info.status==20?'离职交接中':'离职'}}</el-descriptions-item>
        <el-descriptions-item label="管辖区域"><span class="c-main c-pointer" v-if="rowItem.areaCount" @click="showArea">查看管辖区域</span></el-descriptions-item>
      </el-descriptions>
      <el-tabs v-model="activeType" @tab-click="handleCheck" class="mt20 ">
        <el-tab-pane label="基础信息" name="0"></el-tab-pane>
        <el-tab-pane label="他的客户" name="1" v-if="info.status!=30"></el-tab-pane>
        <el-tab-pane label="预约服务" name="2"></el-tab-pane>
        <el-tab-pane label="他的团队" name="3" v-if="info.status!=30"></el-tab-pane>
        <el-tab-pane label="他的业绩" name="4"></el-tab-pane>
        <!-- <el-tab-pane label="他的团队业绩" name="5" v-if="info.status!=30"></el-tab-pane> -->
      </el-tabs>
      <Title class="mt20">{{activeType==0?'其他信息':'统计'}}</Title>
      <template v-if="activeType==0">
        <el-descriptions class="margin-top" title="" :column="3">
          <el-descriptions-item label="注册APP时间">{{info.firstLoginAppTime}}</el-descriptions-item>
          <el-descriptions-item label="入职时间">{{info.createdTime}}</el-descriptions-item>
          <el-descriptions-item label="离职时间" v-if="info.status==30">{{info.resignTime}}</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeType!=0">
        <!-- <div class="flexs" v-if="[2,4].includes(activeType)">
          <el-radio-group v-model="radio1">
            <el-radio-button label="全部"></el-radio-button>
            <el-radio-button label="今日"></el-radio-button>
            <el-radio-button label="本周"></el-radio-button>
            <el-radio-button label="本月"></el-radio-button>
          </el-radio-group>
        </div> -->
        <el-row>
          <el-col :span="8" v-for="(item,index) in statisticsList" :key="index" style="margin-bottom: 40px;">
            <div class="grid-content">
              <div>{{item.label}}</div>
              <div class="flexs justify-between">
                <span><span style="font-size: 50px;">{{item.value || 0}}</span>{{item.unit}}</span>
                <!-- <i class="el-icon-arrow-right" style="font-size: 30px;color: #878787;font-weight: bold;"></i> -->
              </div>
            </div>
          </el-col>
        </el-row>
      </template>
    </el-card>
    <el-dialog title="管辖区域" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
      <el-tree :data="areaOptions" :props="defaultProps"></el-tree>
    </el-dialog>

  </div>
</template>

<script>
import technicianInfoApi from '@/api/technical/technicianInfo'
import technicianAreaApi from '@/api/technical/technicianArea'
import technicianServiceOrderApi from '@/api/technical/technicianServiceOrder'
import clientListApi from '@/api/client/clientList'
export default {
  props: ['rowItem', 'technicalState', 'isServiceTeacher'],
  data() {
    return {
      radio1: '全部',
      activeType: '0',
      list: [],
      formVisible: false,
      info: { userHeadImg: '' },
      technicalState: 1,
      shareData: null,
      defaultProps: {
        children: 'child',
        label: 'areaName'
      },
      areaOptions: [],
      statisticsList: []
    }
  },
  created() {
    this.handleShow()
    // if (this.technicalState) this.getShareData()
  },
  methods: {
    handleShow() {
      let Ins = this.isServiceTeacher ? technicianInfoApi.fetchByIdBig : technicianInfoApi.fetchById
      Ins(this.rowItem.id)
        // technicianInfoApi.fetchById(4)
        .then((data) => {
          this.info = data.data;
          // this.getServiceNum()
          this.getClientNum()
          console.log('this.form: ', this.info);
        })
    },
    showArea() {
      if (this.rowItem.areaCount) this.changeIdentity()
    },
    // 获取业绩
    async getInfo() {
      let Ins = this.isServiceTeacher ? technicianInfoApi.getPerformanceBig : technicianInfoApi.getPerformance
      const { data } = await Ins(this.rowItem.id)
      this.statisticsList.map(i => {
        if (data[i.key]) {
          i.value = data[i.key]
        }
        return i
      })
      // console.log('业绩data: ',data);
    },
    // 获取地区
    changeIdentity() {
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      technicianAreaApi.fetchTreeList({
        techInfoId: this.rowItem.id,
        parentTechInfoId: this.rowItem.parentId,
        addOrDelete: 2,
        v: 3
      }).then(({
        data
      }) => {
        this.loading.close()
        this.areaOptions = data
        this.formVisible = true
      }).catch(() => {
        this.loading.close()
      })
    },
    // 切换
    handleCheck() {
      if (this.activeType == 1) {
        this.statisticsList = [{
          label: '普通客户',
          key: '8',
          unit: '人',
          value: 0
        },
        {
          label: '体验班',
          key: '7',
          unit: '人',
          value: 0
        },
        {
          label: '研修班',
          key: '6',
          unit: '人',
          value: 0
        },
        ]
        this.getClientNum()
      }
      if (this.activeType == 2) {
        this.statisticsList = [{
          label: '总预约服务',
          key: '',
          unit: '次',
          value: 0
        },
        {
          label: '待排期',
          key: '10',
          unit: '次',
          value: 0
        },
        {
          label: '待服务',
          key: '20',
          unit: '次',
          value: 0
        },
        {
          label: '待评论',
          key: '30',
          unit: '次',
          value: 0
        },
        {
          label: '已完成',
          key: '40',
          unit: '次',
          value: 0
        },
        {
          label: '已取消',
          key: '50',
          unit: '次',
          value: 0
        },
        ]
        this.getServiceNum()
      }
      if (this.activeType == 3) {
        this.statisticsList = [{
          label: '技术老师',
          key: '',
          unit: '人',
          value: 0
        }]
        this.getChildNum()
      }
      if (this.activeType == 4) {
        this.statisticsList = [{
          label: '总业绩',
          key: 'performance',
          unit: '元',
          value: 0
        },
        {
          label: '直属客户业绩',
          key: 'performanceForCustomer',
          unit: '元',
          value: 0
        },
        {
          label: '团队业绩',
          key: 'performanceForChild',
          unit: '元',
          value: 0
        }
        ]
        this.getInfo()
      }
      if (this.activeType == 5) {
        this.statisticsList = [{
          label: '总业绩',
          key: '',
          unit: '元'
        },
        {
          label: '直属客户业绩',
          key: '',
          unit: '元'
        },
        {
          label: '团队业绩',
          key: '',
          unit: '元'
        }
        ]
      }
    },
    // 获取预约服务数量
    async getServiceNum() {
      const { data } = await technicianServiceOrderApi.getStatusCount({ technicianInfoId: this.rowItem.id })
      // console.log('服务数量: ',data);
      if (data.length) {
        data.forEach(item => {
          this.statisticsList.map(i => {
            if (i.key == item.id) i.value = item.count
            return i
          })
          this.statisticsList[0].value = data.reduce((total, current) => { return total + current.count }, 0)
        })
        console.log('this.statisticsList: ', this.statisticsList);
      }
    },
    // 获取客户数量
    async getClientNum() {
      let params = { mainId: 0 }
      if (this.isServiceTeacher) {
        params.isBig = true
        params.techInfoIdsForBig = this.info.id
      } else {
        params.technicianId = this.info.id
      }
      const { data } = await clientListApi.getCountByLevelGroup(params)
      // console.log('客户数量data: ',data);
      if (data.length) {
        data.forEach(item => {
          this.statisticsList.map(i => {
            if (i.key == item.id) i.value = item.count
            return i
          })
        })
        // console.log('this.statisticsList: ',this.statisticsList);
      }
    },
    // 获取团队数量
    async getChildNum() {
      const { data } = await technicianInfoApi.getChildCount(this.info.id)
      // console.log('data: ',data);
      this.statisticsList[0].value = data
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.sex-box {
  border-radius: 50%;
  border: 1px solid;
  width: 16px;
  height: 16px;
  margin: 0 4px;
}

.label-box {
  background: #1596cd1a;
  padding: 2px;
  border-radius: 2px;
  color: #1596cd;
}

.grid-content {
  background: #60b7dc33;
  padding: 20px 30px 30px;
  border-radius: 20px;
  font-size: 20px;
  width: 350px;
  height: 153px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
